var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMode = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V6C2 6.36819 2.29848 6.66667 2.66667 6.66667H6C6.36819 6.66667 6.66667 6.36819 6.66667 6V2.66667C6.66667 2.29848 6.36819 2 6 2Z",
  stroke: "currentcolor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.333 2H9.99967C9.63148 2 9.33301 2.29848 9.33301 2.66667V6C9.33301 6.36819 9.63148 6.66667 9.99967 6.66667H13.333C13.7012 6.66667 13.9997 6.36819 13.9997 6V2.66667C13.9997 2.29848 13.7012 2 13.333 2Z",
  stroke: "currentcolor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.333 9.33337H9.99967C9.63148 9.33337 9.33301 9.63185 9.33301 10V13.3334C9.33301 13.7016 9.63148 14 9.99967 14H13.333C13.7012 14 13.9997 13.7016 13.9997 13.3334V10C13.9997 9.63185 13.7012 9.33337 13.333 9.33337Z",
  stroke: "currentcolor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 9.33337H2.66667C2.29848 9.33337 2 9.63185 2 10V13.3334C2 13.7016 2.29848 14 2.66667 14H6C6.36819 14 6.66667 13.7016 6.66667 13.3334V10C6.66667 9.63185 6.36819 9.33337 6 9.33337Z",
  stroke: "currentcolor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMode);
export default ForwardRef;